import * as React from 'react'
import styled, { css } from 'styled-components'
import Typography, { NonLatinLetterSpacingReset, TYPOGRAPHY_ICON_SIZE_CSS_VAR, TYPOGRAPHY_LINE_HEIGHT_CSS_VAR } from './Typography'
import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { setCSSVar } from 'lib/theme/themeUtils'

export const Heading1Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.one.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.one.iconSize)}
  font-family: ${props => props.theme.typography.heading.one.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.one.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.one.fontStyle};
  font-size: 32px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.one.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.one.lineHeightTablet)}
    font-size: 40px;
  }
`

export const Heading1AltStyle = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.oneAlt.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.oneAlt.iconSize)}
  font-family: ${props => props.theme.typography.heading.oneAlt.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.oneAlt.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.oneAlt.fontStyle};
  font-size: 32px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.oneAlt.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.oneAlt.lineHeightTablet)}
    font-size: 40px;
  }
`

export const Heading2Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.two.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.two.iconSize)}
  font-family: ${props => props.theme.typography.heading.two.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.two.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.two.fontStyle};
  font-size: 24px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.two.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.two.lineHeightTablet)}
    font-size: 32px;
  }
`

export const Heading2AltStyle = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.twoAlt.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.twoAlt.iconSize)}
  font-family: ${props => props.theme.typography.heading.twoAlt.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.twoAlt.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.twoAlt.fontStyle};
  font-size: 24px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.twoAlt.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.twoAlt.lineHeightTablet)}
    font-size: 32px;
  }
`

export const Heading3Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.three.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.three.iconSize)}
  font-family: ${props => props.theme.typography.heading.three.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.three.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.three.fontStyle};
  font-size: 20px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.three.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.three.lineHeightTablet)}
    font-size: 24px;
  }
`

export const Heading3AltStyle = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.threeAlt.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.threeAlt.iconSize)}
  font-family: ${props => props.theme.typography.heading.threeAlt.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.threeAlt.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.threeAlt.fontStyle};
  font-size: 20px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.threeAlt.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.threeAlt.lineHeightTablet)}
    font-size: 24px;
  }
`

export const Heading4Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.four.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.four.iconSize)}
  font-family: ${props => props.theme.typography.heading.four.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.four.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.four.fontStyle};
  font-size: 18px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.four.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.four.lineHeightTablet)}
    font-size: 20px;
  }
`

export const Heading5Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.five.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.five.iconSize)}
  font-family: ${props => props.theme.typography.heading.five.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.five.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.five.fontStyle};
  font-size: 16px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.five.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.five.lineHeightTablet)}
    font-size: 18px;
  }
`

export const Heading6Style = css`
  ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.six.lineHeight)}
  ${props => setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, props.theme.typography.heading.six.iconSize)}
  font-family: ${props => props.theme.typography.heading.six.fontFamily};
  letter-spacing: ${props => props.theme.typography.heading.six.letterSpacing};
  ${NonLatinLetterSpacingReset}
  font-style: ${props => props.theme.typography.heading.six.fontStyle};
  font-size: 14px;

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.typography.heading.six.fontWeight};
  }

  ${mediaQueryUp.tablet} {
    ${props => setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, props.theme.typography.heading.six.lineHeightTablet)}
    font-size: 16px;
  }
`

/**
 * CJK characters fill the whole em square, so the tight Latin leading crowds wrapped lines.
 */
const CJK_MIN_LINE_HEIGHT = '1.3em'

/*
  Font sizes are express in px as they are not to be affected by the
  20% REM font decrease at mobile sizes. These font sizes are absolute sizes.
*/
const Element = styled(Typography)`
  /* reset font-style */
  &, &:is(i, em), i, em {
    font-style: normal;
  }

  &:lang(ja), &:lang(ko), &:lang(zh) {
    line-height: max(var(${TYPOGRAPHY_LINE_HEIGHT_CSS_VAR}), ${CJK_MIN_LINE_HEIGHT});
  }

  /* Break Japanese headings between phrase rather than between any two characters (Chrome only) */
  &:where(:lang(ja)) {
    word-break: auto-phrase;
  }

  &.variant-heading1 {
    ${Heading1Style}
  }

  &.variant-heading1alt,
  &.variant-heading1alt:is(i, em),
  &.variant-heading1alt i,
  &.variant-heading1alt em,
  &.variant-heading1:is(i, em),
  &.variant-heading1 i,
  &.variant-heading1 em {
    ${Heading1AltStyle}
  }

  &.variant-heading2 {
    ${Heading2Style}
  }

  &.variant-heading2alt,
  &.variant-heading2alt:is(i, em),
  &.variant-heading2alt i,
  &.variant-heading2alt em,
  &.variant-heading2:is(i, em),
  &.variant-heading2 i,
  &.variant-heading2 em {
    ${Heading2AltStyle}
  }

  &.variant-heading3 {
    ${Heading3Style}
  }

  &.variant-heading3alt,
  &.variant-heading3alt:is(i, em),
  &.variant-heading3alt i,
  &.variant-heading3alt em,
  &.variant-heading3:is(i, em),
  &.variant-heading3 i,
  &.variant-heading3 em {
    ${Heading3AltStyle}
  }

  &.variant-heading4 {
    ${Heading4Style}
  }

  &.variant-heading5 {
    ${Heading5Style}
  }

  &.variant-heading6 {
    ${Heading6Style}
  }
`

interface Props extends Omit<React.ComponentProps<typeof Typography>, 'forwardedAs'> {
  variant: 'heading1' | 'heading1alt' | 'heading2' | 'heading2alt' | 'heading3' | 'heading3alt' | 'heading4' | 'heading5' | 'heading6'
}

function Heading(props: Props) {
  const { variant, as, className, ...rest } = props

  return <Element
    {...rest}
    forwardedAs={as}
    className={clsx(className, `variant-${variant}`)}
  />
}

export default Heading
